<template>
  <div class="select-day-presentation-title">
    {{ presentationString }}
  </div>
</template>

<script>
export default {
  name: 'SelectDayPresentation',

  props: {
    params: {
      type: Object,
      required: true,
    },
  },

  computed: {
    presentationString () {
      return `Доставка ${this.params.format('D MMMM')}, ${this.params.format('dd')}`
    },
  },
}
</script>

<style lang="scss">
  $prefix: 'select-day-presentation-title';

  .#{$prefix} {
    padding-left: 0.16rem;
  }

</style>
